/** Kurzmeldungen zu ausgeführten Aktionen. */
import clsx from 'clsx';
import { useGame } from '../../store/game';

export function ToastStack() {
  const toasts = useGame((s) => s.toasts);
  const dismiss = useGame((s) => s.dismissToast);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-50 flex w-full max-w-sm flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          className={clsx(
            'pointer-events-auto flex animate-fade-in items-start gap-2 rounded-md border p-3 text-sm shadow-lg',
            toast.kind === 'success' && 'border-accent-300 bg-accent-50 text-accent-900 dark:border-accent-800 dark:bg-accent-950 dark:text-accent-200',
            toast.kind === 'error' && 'border-red-300 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950 dark:text-red-200',
            // Eigene Stufe zwischen Hinweis und Fehler: Ein verpasster Auftrag
            // ist keine Störung, aber auch nichts, worüber man hinwegliest.
            toast.kind === 'warning' && 'border-amber-300 bg-amber-50 text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-200',
            toast.kind === 'info' && 'border-panel-300 bg-white text-panel-800 dark:border-panel-700 dark:bg-panel-800 dark:text-panel-100',
          )}
        >
          <span className="mt-0.5 shrink-0" aria-hidden>
            {toast.kind === 'success' ? '✓' : toast.kind === 'error' ? '!' : toast.kind === 'warning' ? '△' : 'i'}
          </span>
          <p className="min-w-0 flex-1">{toast.message}</p>
          <button className="shrink-0 opacity-60 hover:opacity-100" onClick={() => dismiss(toast.id)} aria-label="Schließen">
            ✕
          </button>
        </div>
      ))}
    </div>
  );
}
